import ROUTES from '@client-hub/shared/constants/routes'
import HubLanding from 'routes/index'
import ForgotPassword from 'routes/forgot-password'
import ResetPassword from 'routes/reset-password'
import Login from 'routes/login'
import HubLayout from 'components/HubLayout'
import HubAuthGuard from 'components/HubAuthGuard'
import HubNotFound from 'components/HubNotFound'
import PermissionGuard from 'components/PermissionGuard'
import Dashboard from 'routes/dashboard'
import Users from 'routes/users'
import Product from 'routes/product'
import Client from 'routes/client'
import Help from 'routes/help'
import MfaLogin from 'routes/login/mfa'
import MfaDisable from 'routes/mfa/disable'
import MfaLoginRecovery from 'routes/login/mfa/recovery'
import MfaSetupCode from 'routes/mfa/setup/code'
import MfaSetup from 'routes/mfa/setup'
import MfaEdit from 'routes/mfa/edit'
import MfaEditCode from 'routes/mfa/edit/code'
import MfaSetupBackup from 'routes/mfa/setup/backup-codes'
import MfaEditBackup from 'routes/mfa/edit/backup-codes'
import HubNoAuthGuard from 'components/HubNoAuthGuard'
import TermsOfService from 'routes/terms-services'
import PrivacyPolicy from 'routes/privacy-policy'
import UserAsset from 'routes/user-assets'
import SSO from 'routes/sso'
import Settings from 'routes/settings'
import Error from 'routes/error'

export const routeMap = [
  {
    element: (
      <HubAuthGuard>
        <PermissionGuard>
          <HubLayout />
        </PermissionGuard>
      </HubAuthGuard>
    ),
    children: [
      {
        path: ROUTES.BASE,
        element: <HubLanding />,
      },
      {
        // Dashboard MFE
        path: `${ROUTES.DASHBOARD}/*`,
        element: <Dashboard />,
      },
      {
        // USERS MFE
        path: `${ROUTES.USERS.BASE}/*`,
        element: <Users />,
      },
      {
        // HELP MFE
        path: `${ROUTES.HELP}/*`,
        element: <Help />,
      },
      {
        path: ROUTES.MFA.DISABLE,
        element: <MfaDisable />,
      },
      {
        path: ROUTES.MFA.EDIT.BASE,
        element: <MfaEdit />,
      },
      {
        path: ROUTES.MFA.EDIT.CODE,
        element: <MfaEditCode />,
      },
      {
        path: ROUTES.MFA.EDIT.BACKUP_CODES,
        element: <MfaEditBackup />,
      },
      {
        path: ROUTES.USER_ASSET,
        element: <UserAsset />,
      },
      {
        path: `${ROUTES.SETTINGS.BASE}/*`,
        element: <Settings />,
      },
      {
        path: `${ROUTES.PRODUCT.BASE}/*`,
        element: <Product />,
      },
      {
        path: `${ROUTES.CLIENT.BASE}/*`,
        element: <Client />,
      },
    ],
  },
  {
    // TODO: Get this moved to `/login/sso`
    path: ROUTES.SSO,
    element: <SSO />,
  },
  {
    path: ROUTES.LOGIN.BASE,
    element: (
      <HubNoAuthGuard>
        <Login />
      </HubNoAuthGuard>
    ),
  },
  {
    path: ROUTES.FORGOT_PASSWORD,
    element: (
      <HubNoAuthGuard>
        <ForgotPassword />
      </HubNoAuthGuard>
    ),
  },
  {
    path: ROUTES.RESET_PASSWORD,
    element: (
      <HubNoAuthGuard>
        <ResetPassword />
      </HubNoAuthGuard>
    ),
  },
  { path: ROUTES.LOGIN.MFA.BASE, element: <MfaLogin /> },
  { path: ROUTES.LOGIN.MFA.RECOVERY, element: <MfaLoginRecovery /> },
  { path: ROUTES.MFA.SETUP.BASE, element: <MfaSetup /> },
  { path: ROUTES.MFA.SETUP.CODE, element: <MfaSetupCode /> },
  { path: ROUTES.MFA.SETUP.BACKUP_CODES, element: <MfaSetupBackup /> },
  { path: ROUTES.TERMS_OF_SERVICE, element: <TermsOfService /> },
  { path: ROUTES.PRIVACY_POLICY, element: <PrivacyPolicy /> },
  {
    path: ROUTES.NOT_FOUND,
    element: <HubNotFound returnToHomeLink={ROUTES.BASE} />,
  },
  {
    path: ROUTES.ERROR,
    element: <Error />,
  },
  {
    path: '*',
    element: <HubNotFound returnToHomeLink={ROUTES.BASE} />,
  },
]
